export enum ErrorEnum {
    CART_ERROR,
    ORDER_ERROR,
    TIME_ERROR,
    NETWORK_ERROR,
    NOT_FOUND,
    NO_RESTAURANT,
    NO_CONSUMPTION_MODE,
    QR_CODE_ERROR,
    ORDER_RECEIPT_ERROR,
    UNKNOWN_ERROR,
    MENU_NOT_ACTIVATED,
}

export type ErrorProps = {
    error: ErrorEnum;
    errorMessage?: string;
};
